import React, { FC } from "react";
import { BasicErrorBoundary } from "./BasicErrorBoundary";
import { logError } from "common/utils/logging/Logger";
import { isTestEnv } from "AppData";

export const errorBoundaryFn = "ErrorBoundary.onError";

export const ErrorBoundary: FC = ({ children }) => {
  const onError = (event: any) => {
    logError({ fn: errorBoundaryFn, ...event }, event.originalError);
  };

  if (isTestEnv()) {
    return <>{children}</>;
  } else {
    return <BasicErrorBoundary onError={onError}>{children}</BasicErrorBoundary>;
  }
};
